<template>
  <div class="about-info" :class="{ collapse: collapse }" @click="showDialog = true">
    <div class="about-content">
      <div class="about-title">
        <i class="el-icon-info" />
        <span v-if="!collapse">關於</span>
      </div>
      <div v-if="!collapse" class="about-version">v{{ version }}</div>
    </div>

    <el-dialog
      title="關於"
      :visible.sync="showDialog"
      width="500px"
      :append-to-body="true"
      custom-class="about-info-dialog">
      <div class="about-dialog-content">
        <div class="about-app-name">Ailisi 電子簽名系統</div>
        <div class="about-company">
          <span>艾立斯科技公司出品</span>
          <a href="https://smart-healthcare.com.tw/" target="_blank" rel="noopener noreferrer" class="about-link">
            <i class="el-icon-link" />
            官方網站
          </a>
        </div>
        <div class="about-version-info">版本：{{ version }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AboutInfo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      version: process.env.VUE_APP_VERSION || '1.0.0'
    }
  }
}
</script>

<style lang="scss" scoped>
.about-info {
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #2b2f3a;
  padding: 12px 15px;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.05);

    .about-title {
      color: #42b983;
    }
  }

  .about-content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .about-title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #bfcbd9;
      font-size: 13px;
      transition: color 0.2s;

      i {
        font-size: 14px;
      }
    }

    .about-version {
      color: #909399;
      font-size: 11px;
      margin-left: 22px;
    }
  }

  &.collapse {
    padding: 12px 0;
    text-align: center;

    .about-content {
      align-items: center;

      .about-title {
        justify-content: center;
      }

      .about-version {
        display: none;
      }
    }
  }
}
</style>

<!-- 
  必須使用全局樣式，因為 Dialog 通過 append-to-body 渲染到 body 下
  使用唯一的 custom-class (about-info-dialog) 確保樣式只作用於此 Dialog，不污染全局
-->
<style lang="scss">
@import '@/styles/variables.scss';

// 所有選擇器都從 .about-info-dialog 開始，確保只作用於此 Dialog
// 注意：custom-class 應用在 .el-dialog 元素上，需要設置所有層級的 border-radius
.about-info-dialog {
  border-radius: 12px !important;
  overflow: hidden !important;
  background: transparent !important;

  // 確保 Dialog 本身有圓角
  &,
  &.el-dialog {
    border-radius: 12px !important;
    overflow: hidden !important;
  }

  .el-dialog__header {
    padding: 20px 20px 10px;
    background: $menuBg !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px 12px 0 0 !important;
    margin: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #fff;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .el-dialog__body {
    padding: 20px;
    background: #fff !important;
    border-radius: 0 0 12px 12px !important;
    overflow: hidden !important;
  }

  .about-dialog-content {
    padding: 20px 0;
    text-align: center;

    .about-app-name {
      font-size: 20px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
    }

    .about-company {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      color: #606266;
      font-size: 14px;

      .about-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        color: #42b983;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: #52c994;
          text-decoration: underline;
        }

        i {
          font-size: 14px;
        }
      }
    }

    .about-version-info {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
